const HomePage = () => import("@/pages/HomePage.vue");
const JobsPage = () => import("@/pages/JobsPage.vue");
const PrivacyPage = () => import("@/pages/PrivacyPage.vue");
const DeveloperPage = () => import("@/pages/DeveloperPage.vue");
const NotFoundPage = () => import("@/pages/NotFoundPage.vue");

export const routes = [
  { path: "/", component: HomePage },
  { path: "/jobs", component: JobsPage },
  { path: "/privacy", component: PrivacyPage },
  { path: "/developer", component: DeveloperPage },
  { path: "/404", component: NotFoundPage },
  { path: "/:catchAll(.*)", redirect: "/404" },
];
